export function omitProps(object, ...properties) {
    for (const property of properties) {
        property && delete object[property]
    }

    return object
}

export function isNullish(value) {
    if (value === undefined || value === null || Number.isNaN(value)) return true
    if (typeof value === 'string') return value.trim() === ''
    if (Array.isArray(value)) return value.length === 0
    if (typeof value === 'object') return Object.keys(value).length === 0
    return false
}
